import { ProductsTable } from "components";

const Products = () => {

    return (
        <ProductsTable />
    );

}
export default Products;